import { styled } from 'goober';
import { Button } from '@/ui/button/button';
import { useSidebars } from '@/hooks/use-sidebars';
import { useHasUnreadNotifications } from './hooks/use-has-unread-notifications';

interface NotificationsButtonProps {
  sizeVariant?: 'small' | 'large';
}

export const NotificationsButton = ({
  sizeVariant = 'large',
}: NotificationsButtonProps) => {
  const { toggleNotificationsSidebar } = useSidebars();
  const hasUnreadNotifications = useHasUnreadNotifications();

  return (
    <NotificationsButtonBase
      variant="ghost"
      startIcon={
        hasUnreadNotifications ? 'NotificationsActive' : 'Notifications'
      }
      onClick={toggleNotificationsSidebar}
      shouldModifyIconSvg={false}
      isSmall={sizeVariant === 'small'}
    />
  );
};

const NotificationsButtonBase = styled(Button)<{ isSmall: boolean }>`
  padding: 5px 12px;

  svg {
    width: ${({ isSmall }) => (isSmall ? '17px' : '20px')};
    height: ${({ isSmall }) => (isSmall ? '17px' : '20px')};
  }
`;
